import dataFetcher from "modules/dataFetcher";

import { nonProjectApi } from "services/api";
import store from "services/store";

import { getCurrentTenantUid } from "state/auth/selectors";

export const systemClusterGroupsVisibilityFetcher = dataFetcher({
  selectors: ["systemClusterGroupsVisibility"],
  async fetchData() {
    const tenantUid = getCurrentTenantUid(store.getState());
    const response = await nonProjectApi.get(
      `v1/tenants/${tenantUid}/preferences/clusterGroup`
    );
    return response;
  },
});
